
import Vue from 'vue'
import axios from 'axios'
import * as Sentry from '@sentry/vue'
import { Component } from 'vue-property-decorator'
import { DistributorUser } from '../../global/models'
import DistributorForm from '../components/DistributorForm.vue'
import { consumeError } from '../../global/utils'
import SplitSlider from '../components/SplitSlider.vue'

@Component({
  components: { DistributorForm, SplitSlider }
})
export default class ProviderReadPage extends Vue {
  distributor: DistributorUser | null = null
  loading = false
  agencyPortion = 100

  error: string | null = null

  get distributorId() {
    return this.$route.params.id
  }

  get agencyId() {
    return this.$store.state.auth.agencyId
  }

  mounted() {
    this.getData()
  }

  async getData() {
    this.loading = true
    try {
      const response = await axios.get<DistributorUser>(`/distributors/${this.distributorId}`)
      this.distributor = response.data
      if (this.distributor.distributorLimitPercentage) {
        this.distributor.distributorLimitPercentage = 100 - this.distributor.distributorLimitPercentage
      }
      
      this.loading = false
    } catch (error) {
      if (error.response) {
        switch (error.response.status) {
          case 404:
            this.error = 'not-found'
            break
          case 403:
            this.error = 'unauthorised'
            break
          default:
            this.error = 'generic'
        }
      } else {
        this.error = 'generic'
      }
    }
  }

  async submit() {
    try {
      if (this.distributor && this.distributor.distributorLimitPercentage) {
        this.distributor.distributorLimitPercentage = 100 - this.distributor.distributorLimitPercentage
      }
      await axios.put(`/distributors/${this.distributorId}`, { ...this.distributor })

      this.$router.replace({ name: 'distributors-read', params: { id: this.distributorId.toString() } })
    } catch (error) {
      const formattedError = consumeError(error)
      if (formattedError.code !== 'SENTRY') {
        this.$store.dispatch('error', formattedError.message)
      } else {
        Sentry.captureException(error)
      }
    }
  }
}
